import React from "react"

import { Element } from "legacy/components/shared/base"
import Grid from "legacy/components/shared/Grid"
import ImageAndText from "./ImageAndText"
import { ImageAndTextItemType } from "types/shared-components"
import { Maybe } from "types/Maybe"
import { useTheme } from "src/legacy/utils"
import { getLayoutStyles } from "./helpers"

interface OwnProps {
  data: Maybe<ImageAndTextItemType>
  imageStartsOn: Maybe<string>
  indexIsEven: boolean
  isFirst: boolean
  isLast: boolean
  zIndex: number
}

export type FullBleedImageAndTextProps = OwnProps

const FullBleedImageAndText: React.FC<FullBleedImageAndTextProps> = ({
  data,
  imageStartsOn = "left",
  indexIsEven,
  isFirst,
  isLast,
  zIndex,
}): React.ReactElement | null => {
  if (!data) return null
  const { sizes } = useTheme()
  const gridTemplateAreas = getLayoutStyles(imageStartsOn, indexIsEven)
  const gridTemplateColumns = ["1fr", "1fr", "repeat(2, 1fr)"]
  const widths = ["100%", "600px", sizes.maxWidth]
  const paddingBottom = isLast ? ["50", "85", "0", "0"] : "0"
  const paddingTop = isFirst ? ["50", "85", "0"] : "0"

  return (
    <Element
      pb={paddingBottom}
      position="relative"
      pt={paddingTop}
      px={["0", "50", "0"]}
      zIndex={zIndex}
    >
      <Grid
        gridGap="0"
        gridTemplateAreas={gridTemplateAreas}
        gridTemplateColumns={gridTemplateColumns}
        gridTemplateRows={["1fr auto", "1fr auto", "1fr"]}
        justifyItems={["start", "start", "end"]}
        margin="0 auto"
        maxWidth={widths}
      >
        <ImageAndText
          data={data}
          imageStartsOn={imageStartsOn}
          indexIsEven={indexIsEven}
        />
      </Grid>
    </Element>
  )
}

export default FullBleedImageAndText
